/**
 * Supabase client — browser only.
 * Requires VITE_SUPABASE_URL + VITE_SUPABASE_ANON_KEY.
 * RLS must be enabled on all tables (see supabase/schema.sql).
 */
import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabaseEnabled = Boolean(url && anonKey && !url.includes('YOUR_PROJECT'));

export const supabase: SupabaseClient | null = supabaseEnabled
  ? createClient(url, anonKey, {
      auth: { persistSession: true, autoRefreshToken: true },
    })
  : null;

export async function requireSupabase(): Promise<SupabaseClient> {
  if (!supabase) {
    throw new Error(
      'Supabase not configured. Copy .env.example → .env and set VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY.',
    );
  }
  return supabase;
}
